import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function LeftPanel({ title = 'Important Information', items = [], children }) {
    return (
        <Paper
            elevation={2}
            sx={{
                bgcolor: 'primary.main',
                color: '#fff',
                p: 2,
                boxSizing: 'border-box',
                width: { xs: '100%', md: 270 },
                flexShrink: 0,
                mr: { xs: 0, md: 3 },
                alignSelf: 'flex-start',
                mt: 0,
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
                {title}
            </Typography>
            {items.map((it, idx) => (
                <Typography key={idx} variant="body2" sx={{ mb: idx === items.length - 1 ? 0 : 1.2 }}>
                    {it}
                </Typography>
            ))}
            {children ? <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>{children}</Box> : null}
        </Paper>
    );
}
